<ng-container *appTranslate="let t">
  <div class="w-overlay dialog-form">
    <new-ui-progress-bar [progressid]="progressId" [initialMessage]="initialMessage" />

    @if (cancelable) {
      <div class="col mt-3">
        <new-ui-button
          [fluid]="true"
          [label]="t('common.cancel')"
          icon="icon-[mi--close-medium]"
          severity="secondary"
          (onClick)="cancel()"
        />
      </div>
    }
  </div>
</ng-container>
